//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Report.js";
import "../no/Builder.js";
import "../Report/Report.ProgramInformation.js";
let d=[[[0,"Active",1,0],[0,"Alias",1,0],[0,"DisplayName",1,0],[0,"Name",1,0],[1,"ProgramInformation",0,"Report.ProgramInformation",0]],[[["textLineCount","commandHint"],"GetHint",{},0,0],[["commandHint"],"SetHint",{},1,0],[["pNamespaces"],"SetNamespaces",{},1,0],[["namespacesCount","pNamespaces"],"GetNamespaces",{},0,0],[["argumentType"],"AddArgument",{R_:{pArgument:"Report.BaseArgument"}},1,0],[["argumentsCount","pArguments"],"GetArguments",{},0,0],[["pArguments"],"RemoveArguments",{},1,0],[["userInputLocation","userInputType"],"AddUserInput",{R_:{pUserInput:"Report.UserInput"}},2,0],[["userInputLocation","userInputsCount","pUserInputs"],"GetUserInputs",{},1,0],[["userInputLocation","pUserInputs"],"RemoveUserInputs",{},2,0],[["userInputLocation","pUserInputs","isBeforeRefUserInput","pRefUserInputs"],"MoveUserInputs",{},4,0]],[]];
SPLM.Report.CommandBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Report.CommandBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Report.CommandBuilder.UserInputLocation = Object.freeze({
    "BeforeAutomation" : "BeforeAutomation", "AfterAutomation" : "AfterAutomation"});

export default SPLM;